import { Box, Flex, Text, useColorModeValue, Spinner, Center } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import PieChart from "components/charts/PieChart";
import { VSeparator } from "components/separator/Separator";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../../../constants";
import {getAuthToken} from "../../../../helpers/helpers"

export const pieChartOptions = {
  labels: ["Homme", "Femme", "Enfant"],
  colors: ["#0066FF", "#33FFFF", "#678BF4"],
  chart: {
    width: "50px",
  },
  states: {
    hover: {
      filter: {
        type: "none",
      },
    },
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  hover: { mode: null },
  plotOptions: {
    donut: {
      expandOnClick: false,
      donut: {
        labels: {
          show: false,
        },
      },
    },
  },
  fill: {
    colors: ["#0066FF", "#33FFFF", "#678BF4"],
  },
  tooltip: {
    enabled: true,
    theme: "dark",
  },
};

export default function Conversion({ startDate, endDate, ...rest }) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );

  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let Homme = 0;
      let Femme = 0;
      let Enfant = 0;

      const token = getAuthToken();

      try {
        const response = await axios.get(
          `${API_URL}/api/track/action/AFFICHER_TRAITEMENT`,
          {
            headers: {
              "x-access-token": token,
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const filteredData = response.data.filter((item) => {
          const createdAt = new Date(item.created_at);
          if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            return createdAt >= start && createdAt <= end;
          }
          return true;
        });

        const total = filteredData.length;
        if (total === 0) {
          setChartData([0, 0, 0]);
          setLoading(false);
          return;
        }

        filteredData.forEach((item) => {
          const gender = item.data?.patientProfile?.gender;
          if (gender === "F") Femme++;
          else if (gender === "H") Homme++;
          else if (gender === "E") Enfant++;
        });

        const FemmePercentage = (Femme / total) * 100 || 0;
        const HommePercentage = (Homme / total) * 100 || 0;
        const EnfantPercentage = (Enfant / total) * 100 || 0;

        setChartData([HommePercentage, FemmePercentage, EnfantPercentage]);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setChartData([0, 0, 0]);
        setLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  if (loading || chartData === null) {
    return (
      <Card p="20px" align="center" direction="column" w={{sm: "168%", md: "100%" ,xl :"200%" , "2xl" :"200%" }} {...rest} minH="300px">
        <Center h="100%" minH="250px">
          <Flex direction="column" align="center" gap="4">
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="brand.500"
              size="xl"
            />
            <Text color="secondaryGray.600" fontSize="sm" fontWeight="500">
              Chargement des données patients...
            </Text>
          </Flex>
        </Center>
      </Card>
    );
  }

    return (
        <Card p="20px" align="center" direction="column" w={{sm: "168%", md: "100%" ,xl :"200%" , "2xl" :"200%" }} {...rest}>
    
        <Flex
          direction="column"
          align="center"
          justify="center"
          w="100%"
        >
          <Text
            color={textColor}
            fontSize="xl"
            fontWeight="700"
            mb="20px"
          >
            Répartition par Genre
          </Text>
          <PieChart chartData={chartData} chartOptions={pieChartOptions} />
          <Flex
            direction="column"
            align="center"
            justify="center"
            mt="20px"
            w="100%"
          >
            <Flex justify="center" wrap="wrap" gap="20px">
              <Flex align="center" gap="10px">
                <Box bg="#0066FF" h="10px" w="10px" borderRadius="50%" />
                <Text color={textColor} fontSize="md" fontWeight="500">
                  Homme
                </Text>
                <Text color={textColor} fontSize="md" fontWeight="700">
                  {chartData[0].toFixed(2)}%
                </Text>
              </Flex>
              <Flex align="center" gap="10px">
                <Box bg="#33FFFF" h="10px" w="10px" borderRadius="50%" />
                <Text color={textColor} fontSize="md" fontWeight="500">
                  Femme
                </Text>
                <Text color={textColor} fontSize="md" fontWeight="700">
                  {chartData[1].toFixed(2)}%
                </Text>
              </Flex>
              <Flex align="center" gap="10px">
                <Box bg="#678BF4" h="10px" w="10px" borderRadius="50%" />
                <Text color={textColor} fontSize="md" fontWeight="500">
                  Enfant
                </Text>
                <Text color={textColor} fontSize="md" fontWeight="700">
                  {chartData[2].toFixed(2)}%
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Card>
    );
  }
  
